export default function Cre8orLogo({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 160 70"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Cre8or"
      className={className}
    >
      {/* Infinity / lemniscate loop */}
      <path
        d="M48 18 C36 8, 16 8, 16 22 C16 36, 36 36, 48 26 C60 36, 80 36, 80 22 C80 8, 60 8, 48 18 Z"
        fill="none"
        stroke="#7BB8A8"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* CRE8OR wordmark */}
      <text
        x="4"
        y="55"
        fontFamily="DM Sans, Inter, sans-serif"
        fontWeight="800"
        fontSize="22"
        letterSpacing="2"
        fill="#1A1A1A"
      >
        CRE8OR
      </text>
      {/* Tagline */}
      <text
        x="4"
        y="67"
        fontFamily="DM Sans, Inter, sans-serif"
        fontWeight="400"
        fontSize="7"
        letterSpacing="2.5"
        fill="#6B6B6B"
      >
        CREATE YOUR OWN BRAND
      </text>
    </svg>
  );
}
